import Service from './service'
import StripeBilling from './stripe-billing'

export default class Resources {
  static Service = Service
  static StripeBilling = StripeBilling
}